export const arraysAreShallowEqual = (
  a: readonly (string | number)[],
  b: readonly (string | number)[]
): boolean => {
  return a.length === b.length && a.every((e, index) => b[index] === e);
};
